module.exports = __webpack_public_path__ + "static/img/group-7@3x.8407ec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/group-7@3x.png
// module id = upUD
// module chunks = 6